import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"; //also import Navigate for default routing

import Contact from "./patients/pages/Contact";
import NewPatient from "./patients/pages/NewPatient";
import About from "./practice/pages/About";
import Services from "./practice/pages/Services";
import Welcome from "./practice/pages/Welcome";
import MainNavigation from "./shared/components/Navigation/MainNavigation";

function App() {
  //return <h1>Let's start!</h1>;
  console.log("test");
  let routes;
  routes = (
    <Routes>
      <Route path="/" element={<Welcome />} />
      <Route path="/About" element={<About />} />
      <Route path="/Services" element={<Services />} />
      <Route path="/Contact" element={<Contact />} />
      <Route path="/NewPatient" element={<NewPatient />} />
    </Routes>
  );
  return (
    <Router>
      <MainNavigation />
      <main>{routes}</main>
      <footer className="Footer">
        <div className="Footer__inner">
          <div className="Footer__col">
            <div className="Footer__brand">Monument Dental</div>
            <p>Marcus Bellamy, DMD</p>
            <p>Restorative &amp; cosmetic dentistry in Monument, CO.</p>
          </div>
          <div className="Footer__col">
            <p>
              <a href="https://goo.gl/maps/jh441hWp5yux3qVd9">
                236 Washington Street, Suite 1W
              </a>
            </p>
            <p>Monument, CO 80132</p>
            <p>Mon–Thu · 7:30am–5pm</p>
          </div>
          <div className="Footer__col">
            <p>
              <a href="tel:7194882721">719-488-2721</a>
            </p>
            <p>
              <a href="mailto:monumentdental@hotmail.com">
                monumentdental@hotmail.com
              </a>
            </p>
          </div>
        </div>
        <div className="Footer__bottom">
          © {new Date().getFullYear()} Monument Dental. All Rights Reserved.
        </div>
      </footer>
    </Router>
  );
}

export default App;
